define(["./macroModule",
        "json!../monitoring.json",
        "json!../tdnByEntity.json"],
    function (macroModule, monitoring, tdnByEntity) {
        "use strict";

        return macroModule.controller("macroControllerSearch", [
            "$scope",
            "$q",
            "monitoringService",
            "reload",
            "loadingService",
            "remoteExceptionHandler",
            "macroService",
            "tdnHelp",
            function ($scope, $q, monitoringService, reload, loadingService, remoteExceptionHandler, macroService, tdnHelp) {
                $scope.serviceName = monitoring.services.macrosFilter;
                var template, paginationApi, paginationApiDefer = $q.defer();
                var filterApi, filterApiDefer = $q.defer();

                $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["macro"]

                $scope.search = function (modifiedTemplate) {
                    template = modifiedTemplate;
                    paginationApi.seekPage(1);
                };

                $scope.onRegisterFilterApi = function (api) {
                    filterApi = api;
                    filterApiDefer.resolve();
                };

                $q.all([paginationApiDefer.promise, filterApiDefer.promise]).then(function () {
                    filterApi.onChangeService(function (service) {
                        if (service === $scope.serviceName) {
                            if (reload) {
                                filterApi.reload();
                            } else {
                                filterApi.reset();
                            }
                        }
                    });
                });

                $scope.tableOptions = {
                    records: [],
                    pagination: {
                        onPaginate: function (firstResult, maxResults) {
                            return loadingService(monitoringService.filterMacros("/filter", template, firstResult, maxResults))
                                .then(function (result) {
                                    return result;
                                }).catch(remoteExceptionHandler());
                        }
                    },
                    onRegisterPagination: function (api) {
                        paginationApi = api;
                        paginationApiDefer.resolve();
                    }
                };

                $scope.delete = function (id) {
                    return macroService.delete(id)
                        .finally(function () {
                            filterApi.reload();
                        });
                };
            }]);
    });